import React from 'react'
import { useDispatch } from 'react-redux'
import { IconButton } from '@material-ui/core'
import { FormatSize } from '@material-ui/icons'
import { FONTSIZE } from 'constants/fontSize'
import { increaseFontSize, decreaseFontSize } from 'actions'
import { LANGUAGE } from 'constants/language'
import { useSelector } from 'hook'
import useStyles from './style'
import { ButtonText } from 'text/part'

const TranslateButton = () => {
  const classes = useStyles()
  const fontSizeManager = useSelector((state) => state.fontSizeManager)
  const languageManager = useSelector((state) => state.languageManager)
  const isJP = languageManager === LANGUAGE.JP
  const dispatch = useDispatch()

  return (
    <IconButton
      className={classes.button_text}
      onClick={() => {
        dispatch(
          fontSizeManager === FONTSIZE.LARGE
            ? decreaseFontSize()
            : increaseFontSize()
        )
      }}
    >
      <FormatSize fontSize="large" />
      {isJP ? ButtonText.fontSize.jp : ButtonText.fontSize.en}
    </IconButton>
  )
}

export default TranslateButton
